<template>
    <div>
        <el-dialog
            :title="'Онлайн Кошелек. Баланс ' + convertUnitsToUser(wallet.Amount) + ' ' + getCurrency()"
            :visible.sync="dialogVisible"
            width="435px"
            :close-on-click-modal="false"
        >
            <div v-loading="loading">
                <el-tabs v-model="activeTab">
                    <el-tab-pane :lazy="true" label="Баланс" name="main">

                        <el-form class="m-t-10" ref="validationForm" v-loading="loading">
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-form-item :label="'Пополнить на (' + getCurrency() + ')'">
                                        <el-input-number class="w-100"  :controls="false" v-model="Amount" placeholder="Пополнить на"></el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col v-if="$loginType() === 1" :span="12" align="left" class="d-flex align-items-left">
                                    <el-button class="w-100" icon="el-icon-remove" @click="clean" v-loading="loading">Обнулить</el-button>
                                </el-col>
                                <el-col :span="12" align="right" class="d-flex align-items-right">
                                    <el-button type="primary" class="w-100" icon="el-icon-plus" @click="pay()" v-loading="loading">Пополнить</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane :lazy="true" label="Настройки" name="settings">
                        <el-form class="m-t-10" :model="model">
                            <el-form-item label="Тип кошелька" prop="WalletOnlineType">
                                <el-select @change="model.MaxOverdraft = ''" :clearable="true" v-model="model.WalletOnlineType" placeholder="Тип кошелька" class="w-100">
                                    <el-option
                                        v-for="item in walletTypes"
                                        :key="item.id"
                                        :label="item.name"
                                        :multiple="false"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <template v-if="model.WalletOnlineType === 1">
                                <el-form-item label="Допустимая задолженность (руб)" prop="MaxOverdraft">
                                    <el-input-number class="w-100" :controls="false" v-model="model.MaxOverdraft" placeholder="Допустимая задолженность" />
                                </el-form-item>
                            </template>
                            <template v-else-if="model.WalletOnlineType === 2">
                                <el-form-item label="Допустимая задолженность" prop="MaxOverdraft">
                                    <el-time-select class="w-100" v-model="model.MaxOverdraft" placeholder="Допустимая задолженность" :picker-options="{ start: '00:00', step: '00:05', end: '23:55' }" />
                                </el-form-item>
                                <el-form-item label="Стоимость пополнения (руб/час)" prop="Price">
                                    <el-input-number class="w-100" :controls="false" v-model="model.Price" placeholder="Стоимость пополнения" />
                                </el-form-item>
                            </template>
                            <template v-else-if="model.WalletOnlineType === 3">
                                <el-form-item label="Допустимая задолженность" prop="MaxOverdraft">
                                    <el-input class="w-100" v-model="model.MaxOverdraft" placeholder="Бесплатных парковок" />
                                </el-form-item>
                                <el-form-item label="Стоимость пополнения (рублей за парковку)" prop="Price">
                                    <el-input-number class="w-100" :controls="false" v-model="model.Price" placeholder="Стоимость пополнения" />
                                </el-form-item>
                            </template>
                            <el-row :gutter="20" class="m-t-20">
                                <el-col :span="24" class="align-right">
                                    <el-button type="primary" icon="el-icon-check" @click="apply">Применить</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>

        <el-tag @click="openWallet" style="cursor: pointer; text-decoration: underline; text-decoration-style: dashed;">{{ convertUnitsToUser(wallet.Amount) }} {{getCurrency()}}</el-tag>
    </div>
</template>

<script>
import Vue from 'vue'
const md5 = require('md5')

export default {
    props: [ 'wallet', 'ownerType', 'id' ],
    data () {
        return {
            token: md5('parktime ' + sessionStorage.getItem('token')),
            loading: false,
            activeTab: 'main',
            dialogVisible: false,
            Amount: 0,
            model: {
                MaxOverdraft: this.wallet.MaxOverdraft,
                Price: this.wallet.Price,
                WalletOnlineType: this.wallet.WalletOnlineType
            },
            walletTypes: [
                {
                    id: 1,
                    name: 'Деньги'
                },
                {
                    id: 2,
                    name: 'Время на парковке'
                },
                {
                    id: 3,
                    name: 'Количество парковок'
                },
            ]
        }
    },
    created () {
        switch (this.model.WalletOnlineType) {
            case 1:
                // в копейки
                this.model.MaxOverdraft = this.model.MaxOverdraft / 100
                break
            case 2:
                // в секунды
                this.model.MaxOverdraft = Vue.moment.utc(this.model.MaxOverdraft * 1000).format('HH:mm')
                break
            default:
                break
        }
    },
    methods: {
        openWallet () {
            this.dialogVisible = true
        },
        pay () {
            // operator
            if (this.$loginType() === 1) {
                this.successPurchase()
            }
            else {
                let order = {
                    amount: this.Amount * this.model.Price,
                    currency: 'RUB',
                    order_number: 'wallet-' + this.ownerType + '-' + this.id,
                    description: 'Оплата на онлайн кошелек'
                }
                // eslint-disable-next-line no-undef
                ipayCheckout(order, this.successPurchase, this.failedPurchase)
            }
        },
        successPurchase () {
            let request = {
                Name: 'WalletWriting',
                WalletOnlineWritingCommandType: 0,
                WalletOnlineWritingOwnerType: this.ownerType,
                WalletOnlineWritingCompanyId: (this.ownerType === 1 ? this.id : 0),
                WalletOnlineWritingCustomerId: (this.ownerType === 0 ? this.id : 0),
                WalletOnlineWritingAmount: this.Amount * this.model.Price,
                Hash: this.token
            }

            this.$api.Pay.walletWriting(request).then(response => {
                if (response.Result !== 'Failed') {
                    this.$message({ message: 'Пополнение успешно зарегистрировано', type: 'success' })
                    this.$emit('update')
                    this.dialogVisible = false
                }
                else {
                    let body = {
                        Name: 'RevertPayment',
                        orderId: 'wallet-' + this.ownerType + '-' + this.id,
                        Hash: this.token
                    }
                    this.$api.Pay.reversePayment(body).then(() => {
                        this.$message({ message: 'Ошибка пополнения. Свяжитесь с технической поддержкой.', type: 'error' })
                    })
                }
            }).catch(() => {
                this.$message({ message: 'Ошибка пополнения. Свяжитесь с технической поддержкой.', type: 'error' })
            })
        },
        failedPurchase () {
            this.$message({ message: 'Ошибка оплаты', type: 'error' })
        },
        convertUnitsToBackend (units) {
            switch (this.model.WalletOnlineType) {
                case 1:
                    // в копейки
                    units = units * 100
                    break
                case 2:
                    // в секунды
                    units = units * 3600
                    break
                default:
                    break
            }
            return units
        },
        convertUnitsToUser (units) {
            switch (this.model.WalletOnlineType) {
                case 1:
                    units = parseFloat(units / 100).toFixed(2)
                    break
                case 2:
                    units = parseFloat(units / 3600).toFixed(2)
                    break
                default:
                    units = parseFloat(units).toFixed(2)
                    break
            }
            return units
        },
        getCurrency () {
            let currency = ''
            switch (this.model.WalletOnlineType) {
                case 1:
                    currency = 'руб'
                    break
                case 2:
                    currency = 'час'
                    break
                case 3:
                    currency = 'парк'
                    break
                default:
                    break
            }
            return currency
        },
        clean () {
            let request = {
                Name: 'WalletWriting',
                WalletOnlineWritingCommandType: 2,
                WalletOnlineWritingOwnerType: this.ownerType,
                WalletOnlineWritingCompanyId: (this.ownerType === 1 ? this.id : 0),
                WalletOnlineWritingCustomerId: (this.ownerType === 0 ? this.id : 0),
                WalletOnlineWritingAmount: 0,
                Hash: this.token
            }

            this.$api.Pay.walletWriting(request).then(response => {
                if (response.Result !== 'Failed') {
                    this.$message({ message: 'Обнуление успешно зарегистрировано', type: 'success' })
                    this.$emit('update')
                    this.dialogVisible = false
                }
                else {
                    this.$message({ message: 'Ошибка обнуления. Свяжитесь с технической поддержкой.', type: 'error' })
                }
            }).catch(() => {
                this.$message({ message: 'Ошибка обнуления. Свяжитесь с технической поддержкой.', type: 'error' })
            })
        },
        apply () {
            let request = {
                Name: 'SetItemProperties',
                ItemType: (this.ownerType === 1 ? 'Company' : 'Customer'),
                ItemId: this.id,
                ItemProperties: Object.entries(this.model).map(row => {
                    return {
                        ItemPropertyName: row[0],
                        ItemPropertyValue: row[1]
                    }
                })
            }

            if (this.model.WalletOnlineType === 1) {
                request.ItemProperties[0].ItemPropertyValue = request.ItemProperties[0].ItemPropertyValue * 100
            }
            if (this.model.WalletOnlineType === 2) {
                let time = request.ItemProperties[0].ItemPropertyValue.split(':')
                request.ItemProperties[0].ItemPropertyValue = ((+time[0]) * 60 * 60 + (+time[1] * 60))
            }

            this.$api.Main.editWalletProps(request).then(response => {
                this.loading = false
                if (response.Result === "Success") {
                    this.$message({ message: 'Сохранили настройки кошелька', type: 'success', res: response })
                    this.addVisible = false
                    this.getData()
                }
                else {
                    this.$message({ message: 'Ошибка сохранения настроек кошелька', type: 'error', res: response })
                }
            }).catch((error) => {
                this.loading = false
                this.showFormErrors(error, 'validationForm')
            })

        }
    }
}
</script>

<style scoped>

</style>
